import { render, staticRenderFns } from "./account.vue?vue&type=template&id=35866d85&scoped=true&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&lang=css&"
import style1 from "./account.vue?vue&type=style&index=1&id=35866d85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35866d85",
  null
  
)

export default component.exports